<template>
  <div class="fillin-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <template
      v-if="questionData.content_audio&&questionData.content_audio!=''&&questionData.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent(questionData.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div class="fillin-question-info-view">
      <div class="fillin-question-contents-view">
        <div id="parent1" class="fillin-contentinfo-view"></div>
      </div>
      <div class="fillin-question-options-content-view">
        <div class="fillin-question-select-options-view" v-if="showoption&&!showanswertype">
          <template v-for="optionitem in questioninfo.options[optionindex]">
            <div v-html="optionitem" @click="changeAnswer(optionitem)" v-if="optionitem!=''"
                 class="fill-option-item-view"></div>
          </template>
        </div>
        <div class="fill-toast-view" v-if="!showoption&&!showanswertype">
          <div class="fill-show-toast"></div>
          <div>请单击选择</div>
          <br>
          <div>左侧划线空白处，选择相应的正确答案</div>
        </div>
      </div>
    </div>
    <audio ref="fillinmusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';

  export default {
    name: "fillinbackquestion",
    data() {
      return {
        questioninfo: {},
        optionindex: 0,
        answerindex: 0,
        showoption: false,
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        audiourl: "",
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      initData() {
        this.questioninfo = this.paraseData(JSON.parse(JSON.stringify(this.questionData)));
      },
      paraseData(questiondata) {
        var that = this;
        var parent1 = document.getElementById('parent1');
        if (parent1) {
          parent1.innerHTML = "";
        }
        var questioninfo = {}
        this.optionindex = 0;
        questiondata.answers = questiondata.answer.split("|")
        if (questiondata.answers != null) {
          questiondata.answers.forEach(item => {
            item.replace(/\\n/g, "<br>")
          })
        }
        if (questiondata.answers != null) {
          questiondata.answers.forEach(item => {
            item.replace(/\\n/g, "<br>")
          })
        }
        if (questiondata.options.indexOf("<and>") > -1) {
          var options = questiondata.options.split("<and>")
          var optioninfos = []
          options.forEach(item => {
            optioninfos.push(item.split("|"))
          })
          questiondata.options = optioninfos;
          questiondata.options.forEach((item, index) => {
            if (item instanceof Array) {
              item.forEach(subitem => {
                subitem.replace(/\\n/g, "<br>")
              })
            } else {
              item.replace(/\\n/g, "<br>")
            }
            var items = that.randomSort(item)
            that.$set(questiondata.options, index, items)
          })
        } else {
          if (questiondata.options.indexOf("|") > -1) {
            var optioninfos = []
            optioninfos.push(questiondata.options.split("|"))
            questiondata.options = that.randomSort(optioninfos);
          }

        }
        var thisCount = 0;
        thisCount = this.substring(questiondata.content, "||")
        for (var i = 0; i < thisCount; i++) {
          var idinfo = "answer" + i;
          var html = ""
          html = "<span id='" + idinfo + "' class='answer-t-view fillanswer' style='border-bottom:2px solid #8c939d;color:#131313' @click='test'>" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + "</span>"
          questiondata.content = questiondata.content.replace("||", html)

        }
        var thiscontent = questiondata.content.replace(/\\n/g, "</br>")
        thiscontent = thiscontent.split("</br>");
        var strcontent = ""
        for (var j = 0; j < thiscontent.length; j++) {
          var contentinfo = thiscontent[j];
          console.log(contentinfo)
          if (contentinfo.indexOf("<img>") > -1) {
            var contentitems = contentinfo.split("<img>")
            for (var k = 0; k < contentitems.length; k++) {
              if (contentitems[k].indexOf(".jpeg") > -1 || contentitems[k].indexOf(".png") > -1 || contentitems[k].indexOf(".jpg") > -1) {
                var imgurl = apiUtil.getBaseUrl() + contentitems[k]
                strcontent += "<img data-url='" + imgurl + "' style='width: 180px;height: 180px' src='" + imgurl + "'/>";
              } else {
                strcontent += contentitems[k]
              }
            }
            strcontent += "</br>"
          } else {
            strcontent += contentinfo + "</br>"
          }
        }
        questiondata.content = "<div style='overflow-y: auto;width: 100%;'>" + strcontent + "</div>"
        questioninfo = questiondata
        setTimeout(() => {
          var MyComponent1 = Vue.extend({
            template: questiondata.content,
            data() {
              return {
                allcount: thisCount
              }
            },
            methods: {
              test(e) {
                if (!that.answerfinish && !that.questionfinish) {
                  that.clickthis(e.currentTarget.id.replace("answer", ""))
                }
              },
              playaudio(e) {
                that.playaudio(e)
              },
              chosestyle(i) {
                var fillanswers = document.getElementsByClassName("fillanswer")
                if (that.questioninfo.answers[i] == fillanswers[i].innerHTML) {
                  if (that.trueflag == undefined) {
                    fillanswers[i].setAttribute("style", "border-bottom:2px solid #92C761;color: #92C761")
                  } else {
                    fillanswers[i].setAttribute("style", "border-bottom:2px solid #131313;color: #131313")
                  }
                } else {
                  fillanswers[i].setAttribute("style", "border-bottom:2px solid #F45578;color:#F45578")
                  // fillanswers[i].innerHTML = fillanswers[i].innerHTML + "(" + that.questioninfo.answers[i] + ")"
                }
                // that.playaudiotype(that.trueflag)
              }
            }
          });
          that.component = new MyComponent1().$mount();
          var parent = document.getElementById('parent1');
          parent.innerHTML = "";
          parent.appendChild(that.component.$el);
          if (that.questioninfo.useroption && that.questioninfo.useroption.length > 0) {
            that.inputUseranswer()
          }
        }, 100)
        this.$nextTick(() => {
          that.questioninfo = questioninfo;

        })
      },
      inputUseranswer() {
        this.questioninfo.useroption.forEach((item, index) => {
          document.getElementById(("answer" + index)).innerHTML = item;
          document.getElementById(("answer" + index)).setAttribute("style", "color:#131313;border-bottom:2px solid #8c939d;");
        })
      },
      substring(text, chrt) {
        var str = text;
        var arr = str.split(chrt)
        return arr.length - 1
      },
      changeAnswer(answer) {
        if (answer) {
          this.isCanClick = true;
          document.getElementById(("answer" + this.answerindex)).innerHTML = answer;
          document.getElementById(("answer" + this.answerindex)).setAttribute("style", "color:#131313;border-bottom:2px solid #8c939d;");
          this.answerindex += 1;
          if (this.answerindex >= this.questioninfo.answers.length) {
            this.answerindex -= 1;
          }
          this.optionindex = this.answerindex;
          if (this.questioninfo.options.length <= this.optionindex) {
            this.optionindex = 0;
          }
          var fillanswers = document.getElementsByClassName("fillanswer")
          for (var i = 0; i < fillanswers.length; i++) {
            if (this.answerindex == i) {
              fillanswers[i].setAttribute("style", "background: #5D79FA;color:#fff; border-bottom:2px solid #fff;")
            } else {
              fillanswers[i].setAttribute("style", "border-bottom:2px solid #8c939d;")
            }
          }
          this.checkanswer()
        }
      },
      clickthis(index) {
        this.showoption = true;
        var fillanswers = document.getElementsByClassName("fillanswer")
        for (var i = 0; i < fillanswers.length; i++) {
          if (index == i) {
            fillanswers[i].setAttribute("style", "background: #5D79FA;color:#fff; border-bottom:2px solid #fff;")
          } else {
            fillanswers[i].setAttribute("style", "border-bottom:2px solid #8c939d;background: none;color:#131313;")
          }
        }
        this.answerindex = parseInt(index);
        this.optionindex = this.answerindex;
        if (this.questioninfo.options.length <= this.optionindex) {
          this.optionindex = 0;
        }
        this.checkanswer()
      },
      checkanswer() {
        var that = this;
        var fillanswers = document.getElementsByClassName("fillanswer")
        var useroption = []
        for (var i = 0; i < fillanswers.length; i++) {
          useroption.push(fillanswers[i].innerText);
        }
        that.questioninfo.isfinish = true;
        that.questioninfo.useroption = useroption
        that.$emit("questionfinish", this.questioninfo)
      },
      closeAnswerDialog() {
        var showinfo = document.getElementById('showinfocontent');
        if (showinfo) {
          showinfo.innerHTML = "";
        }
        this.showanswerdialog = false;
      },

      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.fillinmusic.src = audiourl;
        if (this.$refs.fillinmusic.paused) {
          this.$refs.fillinmusic.play();
          this.contentplay = true;
        }
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .fillin-question-view {
    width 100%;
    height 100%;
  }

  .fillin-question-info-view {
    display flex;
    width 100%;
    border-radius 12px;
  }

  .fillin-question-contents-view {
    width 50%;
    height 100%;
    border-right 1px dashed #E5E5E5;
    border-radius 12px;
    background #fff;
  }

  .fillin-question-options-content-view {
    width 50%;
    height 100%;
    border-radius 12px;
    background #fff;
    display flex;
    align-items start;
    overflow-y auto;
  }

  .fillin-contentinfo-view {
    width 98%;
    height 500px;
    display flex;
    text-align left;
    font-size 30px;
    color #131313;
    font-weight normal;
    overflow-y auto;
    margin 50px 15px 10px 15px;
  }

  .fillin-contentinfo-view::-webkit-scrollbar {
    display block !important;
    width: 3px !important; /*高宽分别对应横竖滚动条的尺寸*/
    height: 2px !important;
  }

  .fillin-contentinfo-view::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 10px !important;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    background: #5d79fa !important;
  }

  .fillin-contentinfo-view::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    border-radius: 10px !important;
    background: #EDEDED !important;
  }

  .fillin-question-select-options-view {
    width 100%;
    display flex;
    flex-wrap wrap;
  }

  .fill-option-item-view {
    border 3px solid #000;
    padding 17px 29px;
    border-radius 12px;
    margin 20px;
    font-size 36px;
  }

  .fill-option-item-view:active {
    color #fff;
    background #5777FF;
    border 3px solid #5777FF;
  }

  .answer-t-view {
    line-height 50px;
    margin 10px 3px;
    background #ffffff;
    min-width 50px;
  }

  .fill-toast-view {
    width 100%;
    color #F45578;
    font-size 30px;
    font-weight bold;
  }

  .fill-show-toast {
    width 487px;
    height 241px;
    background url("../../assets/img/fill-show-toast-bg.png")
    background-size 100% 100%;
    margin 0 auto;
  }

  .fill-finish-btn {
    width 50%;
    height 72px;
    font-size 36px;
    position absolute;
    left 25%;
    bottom 30px;
    border-radius 36px;
    background #5777FF;
    color #fff;
  }

  .disable-btn {
    pointer-events: none;
    opacity 0.5
  }

  .fillin-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;
  }

  .fill-finish-view {
    width 100%;
    height 90px;
    display flex;
    position absolute;
    bottom 0;
  }

  .answer-right-bottom-view img {
    margin-right 15px;
  }

  .answer-right-bottom-view {
    display flex;
    flex 1;
    height 100%;
    justify-content center;
    align-items center;
    color #fff;
    font-size 36px;
    background #92C761;
  }

  .fill-finish-wrong {
    width: 100%;
    height 100%;
    display flex;
    justify-content center;
    align-items center;

    .answer-wrong-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 36px;
      background #F45578;
    }

    .answer-wrong-bottom-view img {
      margin-right 15px;
    }

    .show-answer-btn {
      font-size 24px;
      color #fff;
      padding 0 15px;
      display flex;
      height 100%;
      flex-direction column;
      justify-content center;
      align-items center;
      background #92C761;
    }
  }

  .show-answer-dialog {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #65d67a;
    z-index 2000;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .close-answer-dialog {
    background url("../../assets/img/answer-close-bg.png")
    background-size 100% 100%;
    width 180px;
    height 180px;
    position absolute;
    left -90px;
    top -90px;
  }

  .show-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;

    margin auto;
  }

  .dialog-toast-text {
    margin-top 24px;
    font-size 36px;
    color #131313;
    font-weight bold;
  }

  .show-answer-content-info {
    width 50%;
    height 96%;
    margin 1% auto;
    overflow-y auto;
    display flex;
    flex-direction column;
    justify-content center;
    font-size 36px;
    line-height 50px;
  }

  @media screen and  (max-width: 1600px) {
    .fillin-question-info-view {
      top -6%;
    }

    .fillin-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;
    }

    .fill-finish-view {
      width 100%;
      height 50px;
      display flex;
      position absolute;
      bottom 0;
    }

    .fill-finish-btn {
      width 50%;
      height 48px;
      font-size 24px;
      position absolute;
      left 25%;
      bottom 5px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .fillin-contentinfo-view {
      width 98%;
      height 360px;
      display flex;
      text-align left;
      font-size 30px;
      color #131313;
      font-weight normal;
      overflow-y auto;
      margin 50px 15px 10px 15px;
    }

    .answer-right-bottom-view img {
      width 40px;
      height 40px;
      margin-right 15px;
    }

    .answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 24px;
      background #92C761;
    }

    .fill-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #F45578;
      }

      .answer-wrong-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .show-answer-btn {
        font-size 18px;
        color #fff;
        padding 0 15px;
        display flex;
        height 100%;
        flex-direction column;
        justify-content center;
        align-items center;
        background #92C761;
      }

      .show-answer-btn img {
        width 20px;
        height 20px;
      }
    }
  }

  @media screen and  (max-width: 1366px) {
    .fillin-question-info-view {
      top -9%;
    }

    .fillin-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;
    }

    .fill-finish-view {
      width 100%;
      height 50px;
      display flex;
      position absolute;
      bottom 0;
    }

    .fill-finish-btn {
      width 50%;
      height 48px;
      font-size 24px;
      position absolute;
      left 25%;
      bottom 5px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .fillin-contentinfo-view {
      width 98%;
      height 300px;
      display flex;
      text-align left;
      font-size 30px;
      color #131313;
      font-weight normal;
      overflow-y auto;
      margin 50px 15px 10px 15px;
    }

    .answer-right-bottom-view img {
      width 40px;
      height 40px;
      margin-right 15px;
    }

    .answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 24px;
      background #92C761;
    }

    .fill-toast-view {
      width 100%;
      color #F45578;
      font-size 24px;
      font-weight bold;
    }

    .fill-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #F45578;
      }

      .answer-wrong-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .show-answer-btn {
        font-size 18px;
        color #fff;
        padding 0 15px;
        display flex;
        height 100%;
        flex-direction column;
        justify-content center;
        align-items center;
        background #92C761;
      }

      .show-answer-btn img {
        width 20px;
        height 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/fillinbackquestion.vue